import { render, staticRenderFns } from "./ProductizationOtoModal.vue?vue&type=template&id=83980e32&"
import script from "./ProductizationOtoModal.vue?vue&type=script&lang=js&"
export * from "./ProductizationOtoModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductizationOtoModal.vue?vue&type=style&index=0&id=83980e32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports